import { render, staticRenderFns } from "./WorkflowList.vue?vue&type=template&id=015642a2"
import script from "./WorkflowList.vue?vue&type=script&lang=js"
export * from "./WorkflowList.vue?vue&type=script&lang=js"
import style0 from "./WorkflowList.vue?vue&type=style&index=0&id=015642a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports